import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';

const links = [
  { href: '#systems', label: 'Systems' },
  { href: '#stack', label: 'Stack' },
  { href: '#experience', label: 'Experience' },
  { href: '#contact', label: 'Contact' },
];

const Navbar: React.FC = () => {
  return (
    <AppBar position="fixed" elevation={0} sx={{ bgcolor: '#0e4c5c', color: 'white' }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ minHeight: 64, gap: 1 }}>
          <Typography component="a" href="#top" variant="h6" sx={{ color: 'inherit', textDecoration: 'none', fontWeight: 700, mr: 2 }}>
            Srivathsa Kavirayuni
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            {links.map((link) => (
              <Button key={link.href} color="inherit" href={link.href} sx={{ px: { xs: 1, md: 1.5 }, minWidth: 0 }}>
                {link.label}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
